import "./chatdetail.scss";
import { useChatDatabase} from "../../lib/chatDatabase";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DownloadIcon from '@mui/icons-material/Download';
import noAvatarImg from "../../assets/noAvatar.png";

const Chatdetail = () => {
  const {
    currentReceiver,
    isCurrentUserBlocked,
    isReceiverBlocked,
    toggleBlock
  } = useChatDatabase();

  const handleBlock = () => {
    if (!currentReceiver) return;
    toggleBlock();
  };

  return (
    <div className="chatdetail">
      <div className="user">
        <img 
          // src={currentReceiver?.avatar || "/public/noAvatar.png"}
          src={currentReceiver?.avatar || noAvatarImg}
          alt=""
          onError={(e) => { 
            e.target.onerror = null; 
            e.target.src = "/noAvatar.png"; 
          }}
        />

        <h2>
          {currentReceiver?.name || "Select a Chat"}
        </h2>

        <p> 
          Lorem ipsum dolor sit amet.
        </p>
      </div>

      <div className="info">
        <div className="option">
          <div className="title">
            <span>
              Chat Setting
            </span>

            <ExpandMoreIcon />
          </div>
        </div>

        <div className="option">
          <div className="title">
            <span>
              Privacy & help
            </span>

            <ExpandLessIcon />
          </div>
        </div>

        <div className="option">
          <div className="title">
            <span>
              Shared photos
            </span>

            <ExpandMoreIcon />
          </div>

          <div className="photos">
            <div className="photoItem">
              <div className="photoDetail">
                <div className="imgInfo">
                  <img  
                    src={"/public/avatar.png"}
                    alt=""
                  />

                  <span>
                    Photo.png
                  </span>
                </div>

                <DownloadIcon />
              </div>
            </div>
          </div>
        </div>

        <div className="option">
          <div className="title">
            <span>
              Shared Files
            </span>

            <ExpandMoreIcon />
          </div>
        </div>

        <div className="actionButtons">
          <button 
            onClick={handleBlock}
            disabled={isCurrentUserBlocked || !currentReceiver}
            className={isReceiverBlocked ? "blocked": ""}
          >
            {isCurrentUserBlocked 
              ? "You are Blocked" 
              : isReceiverBlocked 
              ? "Unblock User" 
              : "Block User"
            }
          </button>

          <button className="report">
            Report User
          </button>
        </div>
      </div>
    </div>
  )
}

export default Chatdetail;